import { cn } from '@/utils/styles/cn'
import { forwardRef } from 'react'

const Skeleton = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => {
    return <div ref={ref} className={cn('bg-primary/5 animate-pulse rounded-md', className)} {...props} />
})

Skeleton.displayName = 'Skeleton'

export { Skeleton }
